import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateUnit, getProducts } from '../../store/reducers/filterSlice';

class Units extends React.Component {
  constructor(props) {
    super(props);

    this.isSelectedUnit = (unit, option) => {
      if(!!this.props.selectedRange[option] && this.props.selectedRange[option].unit == unit) {
        return true;
      }

      return false;
    };

    this.isDisplayClass = (isoClass) => {
      if(this.props.class == isoClass) {
        return true;
      }

      return false;
    };

    this.changeUnit = (unit) => {
      this.props.updateUnit({
        option: this.props.range.option, 
        unit: unit.unit, 
        from: unit.min, 
        to: unit.max
      })
    }
  }
  render() {
    return (
      <>
        {
          Object.entries(this.props.range.classes).map(rangeClass => 
            rangeClass[1].units.map(unit => {
              if(this.isDisplayClass(rangeClass[0])) {
                return <button className={this.isSelectedUnit(unit.unit, this.props.range.option) ? "selected" : ""} onClick={(e) => { this.changeUnit(unit) }} dangerouslySetInnerHTML={{__html: unit.label}}/>
              }
            })
          )
        }
    </>
    )
  }
}

const mapStateToProps = state => {
  return {
    class: state.filter.request.class,
    selectedRange: state.filter.request.range,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    updateUnit: args => dispatch => {
      dispatch(updateUnit(args));
      dispatch(getProducts());
    }
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Units);